export const MOBILE_REGEX = /^(\+98|0098|98|0)?9\d{9}$/;
export const DATE_REGEX = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
export const PERSIAN_REGEX = /^[\u0600-\u06FF\s]+$/;
export const TETHER_ADDRESS_REGEX = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
